import React from "react";
// Sections
import TopNavbar from "../components/Nav/TopNavbar";
import Header from "../components/Sections/Header";
import Services from "../components/Sections/Services";
import Contact from "../components/Sections/Contact";
import Footer from "../components/Sections/Footer"
import Team from "../components/Sections/Team";
import FutureServices from "../components/Sections/FutureServices";

export default function Landing() {
  return (
    <>
      <TopNavbar />
      <Header />
      <Services />
      <FutureServices />
      <Team />
      <Contact />
      <Footer />
    </>
  );
}


